/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {createAction} from "helpers/createAction";
import {AccountDriver, AccountSignatureRequest} from "types/entities/AccountDriver";
import ajax from "helpers/ajax";
import {DriverAccessCardResponse} from "types/entities/DriverAccessCard";
import SessionAction from "store/session/SessionAction";
import {SessionData} from "types/responses/SessionResponse";

class RegistrationAction {
    static readonly SET_ACCOUNT = "RegistrationAction.SetAccount";
    static readonly REMOVE_GUEST = "RegistrationAction.RemoveGuest";
    static readonly SET_SIGNATURE = "RegistrationAction.SetSignature";
    static readonly SET_WRISTBAND = "RegistrationAction.SetWristband";

    static fetchSetAccount = (account: AccountDriver, withLogin: boolean): ((dispatch) => Promise<AccountDriver>) => {
        return async dispatch => {
            try {
                const response: SessionData = await ajax.post("/online-venue/user/register", {
                    ...account,
                    login_after: withLogin,
                });
                const user = response.user as AccountDriver;
                dispatch(RegistrationAction.setAccount(user));
                const sessionRes = {
                    access_token: response.access_token,
                    token_type: response.token_type,
                    expires_at: response.expires_at,
                    uid: response.uid,
                    home_hall_id: response.home_hall_id,
                    user: user,
                    permissions: response.permissions,
                    watchdogWorking: response.watchdogWorking,
                };
                withLogin && dispatch(SessionAction.setSession(sessionRes));
                return Promise.resolve(user);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    static fetchUpdateGuest = (guest: AccountDriver) => {
        return async dispatch => {
            try {
                let response = await ajax.post("/online-venue/user/edit/" + guest.id, {
                    ...guest,
                });

                dispatch(RegistrationAction.setAccount(response.user));
                return Promise.resolve(response);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    static fetchRemoveGuest = (driver: AccountDriver) => {
        return async dispatch => {
            try {
                let response = await ajax.delete("/online-venue/user/delete/" + driver.id);
                console.log("fetchRemoveGuest - then - response");
                console.log(response);
                dispatch(RegistrationAction.removeGuest(response.user));
                return Promise.resolve(response);
            } catch (err) {
                console.log("fetchRemoveGuest - catch - response");
                console.log(err);
                return Promise.reject(err);
            }
        };
    };

    static fetchSetSignature = (signatureData: AccountSignatureRequest) => {
        return async dispatch => {
            console.log("fetchSetSignature");
            console.log(signatureData);
            try {
                let response = await ajax.post("/online-venue/user/save-signature", {
                    ...signatureData,
                });
                dispatch(RegistrationAction.setAccount(response.driver));
                return response;
            } catch (err) {
                console.log("fetchSetSignature - catch - response");
                console.log(err);
                return err;
            }
        };
    };

    static assignWristband(driver_id: number, code: string) {
        return async dispatch => {
            try {
                let response: DriverAccessCardResponse = await ajax.post("/venue/user/assign-wristband/" + driver_id, {
                    code: code,
                });
                dispatch(RegistrationAction.setWristband(response));
                return Promise.resolve(response);
            } catch (err) {
                console.log("assignWristband - catch - response");
                return Promise.reject(err);
            }
        };
    }

    static setAccount(account: AccountDriver) {
        return createAction(RegistrationAction.SET_ACCOUNT, account);
    }

    static removeGuest(account: AccountDriver) {
        return createAction(RegistrationAction.REMOVE_GUEST, account);
    }

    static setWristband(driverAccessCardResponse: DriverAccessCardResponse) {
        return createAction(RegistrationAction.SET_WRISTBAND, driverAccessCardResponse);
    }
}

export default RegistrationAction;
